import "core-js/modules/es6.object.freeze";
import "core-js/modules/es7.array.includes";
import { FunctionalColor, MainColor } from '../types/color';
import { text, textRefresh } from './text';
import { Variant } from '../types/text-button';
import Color from 'color';
import devError from '../utilities/dev-error';
var TEXT_BUTTON_COLORS = ['primary', 'dark', 'light', 'error', 'gray2'];

var getColor = function getColor(textButtonColor, colors, _mainColor, _variant) {
  if (textButtonColor === void 0) {
    textButtonColor = FunctionalColor.Primary;
  }

  if (!TEXT_BUTTON_COLORS.includes(textButtonColor)) {
    devError("Invalid textButton color. Expected one of " + TEXT_BUTTON_COLORS + ", got: " + textButtonColor + ".");
    return colors.primary;
  }

  return colors[textButtonColor];
};

var getColorRefresh = function getColorRefresh(textButtonColor, colors, mainColor, variant) {
  if (textButtonColor === void 0) {
    textButtonColor = FunctionalColor.Primary;
  }

  if (!variant) {
    if (mainColor === MainColor.Brand) {
      switch (textButtonColor) {
        case FunctionalColor.Primary:
          return colors[FunctionalColor.Brand];

        default:
          return colors[textButtonColor];
      }
    } else {
      switch (textButtonColor) {
        case FunctionalColor.Primary:
          return colors[FunctionalColor.System];

        default:
          return colors[textButtonColor];
      }
    }
  } else {
    if (mainColor === MainColor.Brand) {
      switch (variant) {
        case Variant.Primary:
          return colors[FunctionalColor.Brand];

        case Variant.Dark:
          return colors[FunctionalColor.Dark];

        case Variant.Gray2:
          return colors[FunctionalColor.Gray2];

        case Variant.Light:
          return colors[FunctionalColor.Light];

        default:
          return colors[FunctionalColor.Brand];
      }
    } else {
      switch (variant) {
        case Variant.Primary:
          return colors[FunctionalColor.System];

        case Variant.Dark:
          return colors[FunctionalColor.Dark];

        case Variant.Gray2:
          return colors[FunctionalColor.Gray2];

        case Variant.Light:
          return colors[FunctionalColor.Light];

        default:
          return colors[FunctionalColor.System];
      }
    }
  }
};

var hoverStyles = 'text-decoration: underline;';

var getVisitedStyles = function getVisitedStyles(colorName, colors, _mainColor, _variant) {
  return "\n        color: " + Color(getColor(colorName, colors)).darken(0.05).string() + ";\n    ";
};

var getVisitedStylesRefresh = function getVisitedStylesRefresh(colorName, colors, mainColor, variant) {
  return "\n        color: " + Color(getColorRefresh(colorName, colors, mainColor, variant)).darken(0.05).string() + ";\n    ";
};

export var textButtons = Object.freeze({
  getColor: getColor,
  getVisitedStyles: getVisitedStyles,
  getWeight: text.getWeight,
  hoverStyles: hoverStyles
});
export var textButtonsRefresh = Object.freeze({
  getColor: getColorRefresh,
  getVisitedStyles: getVisitedStylesRefresh,
  getWeight: textRefresh.getWeight,
  hoverStyles: hoverStyles
});